import React from 'react';
import ReactLoading from 'react-loading';

const LoadingBar = ({type, color}) => {
	return ( 
		<ReactLoading type={type} color={color} height={50} width={50} />
	 );
}
 
export default LoadingBar;